var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccordionChevron = function SvgAccordionChevron(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20336 10.2953C5.07863 10.1642 5.00856 9.98638 5.00856 9.80099L5.00027 4.20523C4.9995 4.1124 5.01634 4.02033 5.04979 3.93441C5.08324 3.84849 5.13264 3.77042 5.19511 3.70478C5.25758 3.63913 5.33187 3.58722 5.41364 3.55206C5.4954 3.51691 5.58301 3.49922 5.67135 3.50003C5.7597 3.50083 5.847 3.52012 5.92817 3.55676C6.00934 3.5934 6.08276 3.64667 6.14413 3.71344L8.80544 6.51007C8.93017 6.64118 9.00024 6.81898 9.00024 7.00437C9.00024 7.18976 8.93017 7.36756 8.80544 7.49867L6.14413 10.2953C6.01937 10.4264 5.85017 10.5 5.67375 10.5C5.49733 10.5 5.32813 10.4264 5.20336 10.2953Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccordionChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "AccordionChevron.512bb1e4863af1b7648d28feec6746cd.svg";